import { useNavigate } from 'react-router-dom'
import { ExclamationTriangleIcon, XMarkIcon } from '@heroicons/react/24/solid'
import { useTranslation } from 'react-i18next'
import { useAuthStore } from '@/stores/auth.store'

export function ImpersonationBanner() {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const isImpersonating = useAuthStore((s) => s.isImpersonating)()
  const impersonationUserId = useAuthStore((s) => s.impersonationUserId)
  const stopImpersonation = useAuthStore((s) => s.stopImpersonation)

  if (!isImpersonating) return null

  function handleStop() {
    stopImpersonation()
    navigate('/app/admin/users')
    window.location.reload()
  }

  return (
    <div className="fixed top-0 left-0 right-0 z-[9999] bg-amber-500 text-white px-4 py-2 flex items-center justify-between text-sm font-medium shadow-lg">
      <div className="flex items-center gap-2">
        <ExclamationTriangleIcon className="w-4 h-4 shrink-0" />
        <span>
          {t('admin.impersonating')} <code className="bg-amber-600 px-1 rounded text-xs">{impersonationUserId}</code>
          {' '}{t('admin.impersonatingNote')}
        </span>
      </div>
      <button
        onClick={handleStop}
        className="flex items-center gap-1 bg-amber-600 hover:bg-amber-700 px-3 py-1 rounded-lg transition-colors text-xs font-semibold"
      >
        <XMarkIcon className="w-3.5 h-3.5" />
        {t('admin.stopImpersonation')}
      </button>
    </div>
  )
}
